import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function DeletePermissionModal({
  modalData,
  deleteUser,
  isOpen,
  onClose,
}) {
  const { t } = useTranslation('login');
  const handleDelete = () => {
    console.log('user to be dleted', modalData.id);
    deleteUser(modalData.id);
  };

  useEffect(() => {
    const modalElement = document.getElementById('permissions-delete');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
    return () => {
      modalInstance.hide();
    };
  }, [isOpen]);
  return (
    <div
      className="modal fade"
      id="permissions-delete"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <span className="delete">
              <img src="images/delete-simple.svg" alt="" />
            </span>
            <div className="text">
              <h5>{t('AREYOUSUREYOUWANTTODELETE?')}</h5>
              {/* <h6>
                
              </h6> */}
            </div>
            <div className="bottom-button">
              <button
                className="cancel"
                onClick={() => {
                  onClose('delete');
                }}
              >
                {t('CANCEL')}
              </button>
              <button className="sure" onClick={handleDelete}>
                {t('YES,I’MSURE')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
